export const menuItems = [
    {
        id: "0",
        link: "/",
        title: "about",
        mobileOnly: true,
    },
    {
        id: "1",
        link: "/rsisystemy",
        title: "systems",
    },
    {
        id: "2",
        link: "/rsigestorzy",
        title: "issuers",
        // children: [
        //     {
        //         id: "2-2",
        //         link: "/rsigestorzy?nazwa=&typ=ministerstwo",
        //         title: "Ministerstwo / KPRM",
        //     },
        //     {
        //         id: "2-0",
        //         link: "/rsigestorzy?nazwa=&typ=pozosta%C5%82a+administracja+centralna",
        //         title: "Pozostała administracja centralna",
        //     },
        //     {
        //         id: "2-1",
        //         link: "/rsigestorzy?nazwa=&typ=administracja+terenowa",
        //         title: "Administracja terenowa",
        //     },
        // ],
    },
    {
        id: "3",
        link: "/rsiobiekty",
        title: "types",
        children: [
            {
                id: "2-3",
                link: "/rsiobiekty?typ_obiektu__icontains=osoba+fizyczna",
                title: "Osoba fizyczna",
            },
            {
                id: "2-5",
                link: "/rsiobiekty?typ_obiektu__icontains=podmiot",
                title: "Podmiot",
            },
            {
                id: "2-1",
                link: "/rsiobiekty?typ_obiektu__icontains=obiekt+przestrzenny",
                title: "Obiekt przestrzenny",
            },
            {
                id: "2-0",
                link: "/rsiobiekty?typ_obiektu__icontains=inny",
                title: "Inny",
            },
        ],
    },
    {
        id: "4",
        link: "/rsicechy",
        title: "features",
    },
];
